var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-park',{attrs:{"type":_vm.name,"theme":"outline","size":_vm.size,"strokeWidth":_vm.strokeWidth,"fill":_vm.fill}})
}
var staticRenderFns = []

export { render, staticRenderFns }